export const TRANSACTION_TYPES = {
  0: "other|historyPage|any",
  1: "other|historyPage|walletTopUp",
  9: "other|historyPage|commonTopUp",
  2: "other|historyPage|coinholdTopUp",
  10: "other|historyPage|referralPaymentsToMining",
  30: "other|historyPage|withdrawFromWallet",
  31: "other|historyPage|withdrawFromWalletFree",
  42: "other|historyPage|withdrawToCard",
  51: "other|historyPage|miningIncomeToWallet",
  52: "other|historyPage|referralPaymentsToWallet",
  54: "other|historyPage|coinholdPromoBonus",
  55: "other|historyPage|coinholdReferralAccrual",
  56: "other|historyPage|additionalAccrual",
  57: "other|historyPage|exchangeCoin",
  66: "other|historyPage|spendingP2P",
  67: "other|historyPage|topUpP2P",
  69: "other|historyPage|commissionP2P",
  70: "other|historyPage|refundRejectedWithdrawal",
  71: "other|historyPage|refundWithdrawalFee",
  74: "other|historyPage|offerCreationP2P",
  75: "other|historyPage|delistingFromPublicationP2P",
  82: "other|historyPage|refundCanceledFreeWithdrawal",
  85: "other|historyPage|sharedMiningIncome",
  86: "other|historyPage|withdrawToCard",
  90: "other|historyPage|withdrawFromWalletFree",
  91: "other|historyPage|walletTopUp",
  92: "other|historyPage|miningIncomeToWallet",
  132: "other|historyPage|giftCardPurchase",
  133: "other|historyPage|giftCardSystemOperations",
};

// Типы операций, которые запрашиваем в истории кошелька (POST /history/users отдаёт только перечисленные)
export const WALLET_HISTORY_TYPE_IDS = [
  0, 1, 2, 9, 10, 30, 31, 42, 51, 52, 54, 55, 56, 57, 66, 67, 69, 70, 71, 74,
  75, 82, 85, 86, 90, 91, 92, 132, 133,
];
